import {
  GETCUSTOMERDETAILS_SUCCESS,
  GETCUSTOMERDETAILS_FAILED,
  RESET_GETCUSTOMERDETAILS,
  LOADING_GETCUSTOMERDETAILS,
  NETWORK_ERROR_GETCUSTOMERDETAILS,
} from "../types/index";

const initialState = {
  isLoading: false,
  success: false,
  network: false,
  failed: false,
  data: {},
  message: "",
  networkError: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_GETCUSTOMERDETAILS:
      return {
        ...state,
        isLoading: true,
        success: false,
        failed: false,
        network: false,
        data: {},
        message: "",
        networkError: "",
      };
    case GETCUSTOMERDETAILS_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: true,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case GETCUSTOMERDETAILS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        failed: false,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case NETWORK_ERROR_GETCUSTOMERDETAILS:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: false,
        network: true,
        data: {},
        message: "",
        networkError: "",
      };
    case RESET_GETCUSTOMERDETAILS:
      return (state = initialState);
    default:
      return state;
  }
};
